import Logo from "../assets/Logo.svg";
import smallLogo from "../assets/fav.svg";

export default function AppShellLoader({ showSidebar = true }) {
  return (
    <div className="flex h-screen bg-[#F8FAFC]">
      {showSidebar ? (
        <aside className="hidden md:flex w-[210px] flex-col bg-white border-r border-[#E4E7EC]">
          <div className="px-6 py-5 border-b border-[#F0F2F5]">
            <img src={Logo} alt="Dockie" className="w-[66px] h-[21px] object-contain" />
          </div>
          <div className="px-3 py-4 space-y-2">
            {Array.from({ length: 6 }).map((_, idx) => (
              <div key={idx} className="h-8 rounded-lg bg-[#F2F4F7] animate-pulse" />
            ))}
          </div>
        </aside>
      ) : null}

      <main className="flex flex-1 justify-center items-center px-6">
        <div className="flex flex-col gap-3 items-center">
          <img src={smallLogo} alt="Dockie" className="w-10 h-10 dockie-loader-bounce" />
        </div>
      </main>
    </div>
  );
}
